import React, { useState, useCallback, useEffect } from 'react';
import { useParams } from "react-router-dom";

import { Page, Layout, LegacyCard, List } from '@shopify/polaris';

import { DateRangeCustom } from './DateRangeCustom';
import { SkeletonPageCustom } from './SkeletonPageCustom';
import { MoneyFormatCustom } from './MoneyFormatCustom';

import { FetchCustom } from './FetchCustom';
import { useHostNavigate } from "../hooks";

export function Analytic(props) {
    const params = useParams();
    const navigate = useHostNavigate();

    const [loading, setLoading] = useState(true);
    const [model, setModel] = useState({});
    const [reloading, setReloading] = useState(false);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [redirectUrl, setRedirectUrl] = useState('');

    const fetch = FetchCustom();

    const getLocalFiltes = function () {
        var l_startDate = localStorage.getItem(`${props.user.myShopifyDomain}_analytics_${params.id}_startDate`);
        if (!l_startDate) {
            l_startDate = 'allTime';
        }

        var l_endDate = localStorage.getItem(`${props.user.myShopifyDomain}_analytics_${params.id}_endDate`);
        if (!l_endDate) {
            l_endDate = 'allTime';
        }

        return { startDate: l_startDate, endDate: l_endDate };
    }

    const populateData = async () => {
        setReloading(true);

        const data = await fetch(`api/home/analytic?campaignId=${params.id}&startDate=${startDate}&endDate=${endDate}`);

        if (data.reauthorizeUrl) {
            return;
        }

        props.setIsLoading(false);

        if (data.redirectUrl) {
            setRedirectUrl(data.redirectUrl);
        }
        else {
            setModel(data);
            setLoading(false);
            setReloading(false);
        }
    };

    const getUser = async () => {
        if (!props.userLoaded) {
            props.setUserLoaded(true);
            const data = await fetch('api/home/userInfo');

            if (data.redirectUrl) {
                setRedirectUrl(data.redirectUrl);
            }
            else if (JSON.stringify(props.user) !== JSON.stringify(data)) {
                props.setUser(data);
                localStorage.setItem('user', JSON.stringify(data));
            }
        }
    };

    const handleDateRangeChange = useCallback(
        (l_startDate, l_endDate) => {
            setStartDate(l_startDate);
            setEndDate(l_endDate);

            localStorage.setItem(`${props.user.myShopifyDomain}_analytics_${params.id}_startDate`, l_startDate);
            localStorage.setItem(`${props.user.myShopifyDomain}_analytics_${params.id}_endDate`, l_endDate);
        },
        [props.user.myShopifyDomain, params.id],
    );

    useEffect(() => {
        getUser();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (JSON.stringify(props.user) !== '{}') {
            document.title = "Analytics | Stack Discounts";
            props.setIsLoading(true);

            var lfs = getLocalFiltes();

            setStartDate(lfs.startDate);
            setEndDate(lfs.endDate);
        }
        // eslint-disable-next-line
    }, [params.id, props.user]);

    useEffect(() => {
        if (startDate !== '' && endDate !== '') {
            populateData();
        }
        // eslint-disable-next-line
    }, [startDate, endDate]);

    useEffect(() => {
        if (redirectUrl) {
            navigate(redirectUrl);
        }
    }, [redirectUrl, navigate]);

    return (
        loading ?
            <SkeletonPageCustom />
            :
            <Page title={`${model.campaignName}`} titleMetadata="Analytics">
                <Layout>
                    <Layout.Section>
                        <DateRangeCustom
                            label="Date range"
                            fieldName="dateRange"
                            startDate={startDate}
                            endDate={endDate}
                            showAllTime={true}
                            titleInPlace={true}
                            handleChange={handleDateRangeChange}
                        />
                    </Layout.Section>
                    <Layout.Section>
                        <LegacyCard>
                            <List type="bullet">
                                <List.Item>{model.impressions + ' impressions'}</List.Item>
                                <List.Item>{model.applies + ' applies'}</List.Item>
                                <List.Item>{model.converted + ' converted'}</List.Item>
                                <List.Item><MoneyFormatCustom price={model.discountAmount} format={props.user.moneyFormat} /> discount provided</List.Item>
                            </List>
                        </LegacyCard>
                    </Layout.Section>
                    <Layout.Section>
                        <LegacyCard>
                        </LegacyCard>
                    </Layout.Section>
                </Layout>
            </Page>
    );
}